module.exports = __webpack_public_path__ + "images/emoji/tropical_drink.1896020e28ac79b84295.png";